<script>
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Actions',
		meta: [
			{
				name: 'Actions',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			applicants: {},
			assigned_tasks: {},
			types: [
				{ value: '4', text: 'Volunteer' },
				{ value: '3', text: 'Mentor' },
			],
			preservePage: 1,
			pageLimit: 50,
			isLoading: false,
			noRecord: false,
			locations: {},
			aNoRecord: false,
			showAssignedTasks: false,
			searchForm: {
				username: null,
				location: null,
				user_type_id: null,
			},
			sort: {
				isSorted: false,
				sortKey: null,
				sortValue: null,
			},
			currentUserData: JSON.parse(localStorage.getItem('user')),
		};
	},
	mounted() {
		this.getApplicants();
		this.getLocations();
	},
	methods: {
		getApplicants(page) {
			this.isLoading = true;
			this.noRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;

			if (this.searchForm.username) {
				filter += '&username=' + this.searchForm.username;
			}
			if (this.searchForm.location) {
				filter += '&location_id=' + this.searchForm.location;
			}
			if (this.searchForm.user_type_id) {
				filter += '&user_type_id=' + this.searchForm.user_type_id;
			}

			//if not admin
			if (this.currentUserData.user_type_id !== 1 && this.currentUserData.user_type_id !== 5) {
				filter += '&location=yes';
				filter += '&user_id=' + this.currentUserData.id;
			}

			if (this.sort.isSorted) {
				filter += '&sort_key=' + this.sort.sortKey;
				filter += '&sort_value=' + this.sort.sortValue;
			}

			axios
				.get('admin/users/all/applicants?pagination=true&page=' + page + filter)
				.then((res) => {
					this.applicants = res.data.response;
					this.isLoading = false;
					if (!this.applicants.data.length) {
						this.noRecord = true;
						if (page > 1) {
							this.getApplicants(page - 1);
						}
					}
				})
				.catch((err) => {
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},

		...authFackMethods,

		resetForm() {
			this.searchForm.username = null;
			this.searchForm.location = null;
			this.searchForm.user_type_id = null;

			this.getApplicants();
		},

		filterResults() {
			this.getApplicants();
		},

		doSort(key) {
			this.sort.isSorted = true;
			if (this.sort.sortValue == null) {
				this.sort.sortValue = 'asc';
			} else if (this.sort.sortValue == 'asc') {
				this.sort.sortValue = 'desc';
			} else {
				this.sort.sortValue = null;
				this.sort.isSorted = false;
			}

			this.sort.sortKey = key;

			this.getApplicants();
		},

		getLocations() {
			axios.get('admin/locations').then((res) => {
				this.locations = res.data.response;
			});
		},
		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
	},
};
</script>

<style scoped>
.sortable {
	position: relative;
	cursor: pointer;
}
.sortable .fa {
	position: absolute;
	right: 30px;
	top: 15px;
}
</style>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="card">
			<div class="card-body">
				<div class="d-flex">
					<div class="me-2">
						<h5 class="card-title mb-3">Approvals</h5>
					</div>
				</div>

				<form class="row align-items-center form-inline mb-4 border p-3 m-0" @submit.prevent="filterResults">
					<div class="col-md-4">
						<label>User Name / Task</label>
						<input v-model="searchForm.username" type="text" class="ps-4 form-control" placeholder="Type User Name or Task" :disabled="isLoading" />
					</div>
					<div class="col-md-4">
						<label>Location</label>
						<b-form-select class="form-select" v-model="searchForm.location" :options="locations" value-field="id" text-field="name" :disabled="isLoading">
							<option slot="first" :value="null">-- All Locations --</option>
						</b-form-select>
					</div>
					<div class="col-md-4">
						<label>User Type</label>
						<b-form-select class="form-select" v-model="searchForm.user_type_id" :options="types" :disabled="isLoading">
							<option slot="first" :value="null">-- All User Types --</option>
						</b-form-select>
					</div>
					<div class="col-md-4"></div>
					<div class="col-md-4 d-grid">
						<label>&nbsp;</label>
						<button type="button" @click="resetForm" class="btn btn-light btn-reset ms-2" id="show-btn"><i class="bx bx-reset"></i> Reset</button>
					</div>
					<div class="col-md-4 d-grid">
						<label>&nbsp;</label>
						<button type="submit" class="btn btn-block btn-primary" :disabled="isLoading"><i class="bx bx-search-alt-2"></i> Search</button>
					</div>
				</form>

				<div class="table-responsive">
					<table class="table table-bordered table-hover table-striped align-middle mb-0">
						<thead class="table-light">
							<tr>
								<th scope="col" class="sortable" @click="doSort('users.first_name')">
									Name
									<i v-if="sort.sortKey == 'users.first_name' && sort.sortValue == 'asc'" class="fa fa-sort-down"></i>
									<i v-else-if="sort.sortKey == 'users.first_name' && sort.sortValue == 'desc'" class="fa fa-sort-up"></i>
									<i v-else class="fa fa-sort"></i>
								</th>
								<th scope="col" class="sortable" @click="doSort('approvals.user_current_status')">
									Task
									<i v-if="sort.sortKey == 'approvals.user_current_status' && sort.sortValue == 'asc'" class="fa fa-sort-down"></i>
									<i v-else-if="sort.sortKey == 'approvals.user_current_status' && sort.sortValue == 'desc'" class="fa fa-sort-up"></i>
									<i v-else class="fa fa-sort"></i>
								</th>
								<th scope="col" class="sortable" @click="doSort('locations.name')">
									Location
									<i v-if="sort.sortKey == 'locations.name' && sort.sortValue == 'asc'" class="fa fa-sort-down"></i>
									<i v-else-if="sort.sortKey == 'locations.name' && sort.sortValue == 'desc'" class="fa fa-sort-up"></i>
									<i v-else class="fa fa-sort"></i>
								</th>
								<th scope="col">Due Date</th>
								<th scope="col">Role</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="noRecord">
								<td colspan="5" class="p-0">
									<p class="font-size-16 text-center mt-2 mb-0">Record Not Found!</p>
								</td>
							</tr>

							<tr v-if="isLoading">
								<td colspan="5" class="text-center p-0">
									<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
								</td>
							</tr>

							<tr v-else v-for="(applicant, applicantIndex) in applicants.data" :key="applicantIndex">
								<td>
									<h5 class="font-size-13 text-truncate mb-1">
										<router-link tag="a" :to="`/approvals/user/${applicant.approval_id}/${applicant.id}`" target="_blank">
											{{ applicant.first_name != null ? getFullName(applicant) : applicant.username ? applicant.username : 'N/A' }}
										</router-link>
									</h5>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										<!--<span v-if="applicant.psv_check == 'applicant' || applicant.user_current_status == 'applicant'">Review Application</span>-->
										<span>{{ applicant.user_current_status }}</span>
									</p>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										{{ applicant.location }}
									</p>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										{{ applicant.application_date }}
									</p>
								</td>

								<td>
									<p v-if="applicant.approval_user_type_id == 3" class="text-muted mb-0 text-wrap">Mentor</p>
									<p v-else class="text-muted mb-0 text-wrap">Volunteer</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<pagination class="mt-4" :data="applicants" :limit="10" @pagination-change-page="getApplicants"></pagination>
			</div>
		</div>
	</Layout>
</template>
